var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87477 30.1252 1.66666 20 1.66666C9.87474 1.66666 1.66663 9.87477 1.66663 20C1.66663 30.1252 9.87474 38.3333 20 38.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69219 9.36057L17.4553 21.0775L8.63696 30.6039H10.6218L18.3424 22.2632L24.5802 30.6039H31.3341L22.0778 18.228L30.2859 9.36057H28.3011L21.1911 17.042L15.4461 9.36057H8.69219ZM11.6109 10.8224H14.7137L28.415 29.142H25.3123L11.6109 10.8224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXimg);
export default __webpack_public_path__ + "static/media/ximg.65267774484b5d1a765bd7bff1eff359.svg";
export { ForwardRef as ReactComponent };